import {
  anchorHit,
  cardScore,
  deriveResult,
  gradeLeg,
  scorerIdsFromEvents,
  type Fixture,
  type Prediction
} from '@h2h/shared';
import { isPerfectCard } from '../screens/play/fixtures-tab/gradePick';

export interface PickOutcome {
  score: string;
  points: number;
  live: boolean;
  perfect: boolean;
  clock?: string;
}

/** Live or settled card score for display — uses stamped `cardScore` when present. */
export function pickOutcome(prediction: Prediction, fixture: Fixture): PickOutcome | null {
  if (fixture.status === 'SETTLED' && fixture.result) {
    const baseHit = anchorHit(prediction, fixture.result);
    let correct = baseHit ? 1 : 0;
    let attempted = 1;
    for (const leg of prediction.legs ?? []) {
      const g = gradeLeg(leg, fixture.result);
      if (!g.gradeable) continue;
      attempted++;
      if (g.hit) correct++;
    }
    return {
      score: `${fixture.result.homeGoals}–${fixture.result.awayGoals}`,
      points: prediction.cardScore ?? cardScore(prediction, fixture.result),
      live: false,
      perfect: isPerfectCard(correct, attempted)
    };
  }
  if (fixture.status === 'LIVE') {
    const h = fixture.liveHomeGoals ?? 0;
    const a = fixture.liveAwayGoals ?? 0;
    const ht =
      fixture.liveHalftimeHome != null && fixture.liveHalftimeAway != null
        ? { home: fixture.liveHalftimeHome, away: fixture.liveHalftimeAway }
        : null;
    const live = deriveResult(fixture.fixtureId, h, a, scorerIdsFromEvents(fixture.events), ht);
    return {
      score: `${h}–${a}`,
      points: cardScore(prediction, live),
      live: true,
      perfect: false,
      clock: fixture.elapsed != null ? `${fixture.elapsed}'` : 'LIVE'
    };
  }
  return null;
}
